import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation, useHistory } from 'react-router-dom';
import * as R from 'ramda';
import $ from 'jquery';

import { AddPartnerUser } from './../_common/AddPartnerUser';
import { DeletePartnerUser } from './../_common/DeletePartnerUser';
import { UsersTable } from './table';

import anticipa from './../../../../assets/images/svg/112-person.svg';
import facilita from './../../../../assets/images/svg/113-funeral.svg';
import usersIcon from './../../../../assets/images/svg/114-users.svg';
import Emptylustration from './../../../../assets/images/svg/057-contract-1.svg';
import * as urls from '../../../../constants/webapi/backoffice/dossiers';
import { getAuthenticationUrl } from '../../../../constants/webapi/auth';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { GetUsersByPartnerId, GetUsersByPartnerIdDefault } from '../../../../actions/backoffice/partners';
import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import BackofficeUser from '../../../../constants/models/backofficeUser';
import { LoadingState } from '../../../../_common/loadingState';


export const PartnersUsers = ({ partner, isLoading, partnerState }) => {

	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const history = useHistory();
	const pageQuery = new URLSearchParams(searchQuery.search);

	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let role = pageQuery.get('role');
	let status = pageQuery.get('status');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	role = R.isNil(role) ? "" : role;
	status = R.isNil(status) ? "" : status;
	sortBy = R.isNil(sortBy) ? "firstName" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "false" : sortDesc;

	const [selectedUser, setSelectedUser] = useState(undefined);
	const [pageSearch, setPageSearch] = useState(search);
	const [usersStats, setUsersStats] = useState({ anticipa: 0, facilita: 0, total: 0 });
	const renderRef = useRef(false);


	useEffect(() => {
		async function getUsersDefault() {
			try {
				const allUsers = await GetUsersByPartnerIdDefault(partner.id);
				const totalStatusAmount = allUsers.items.reduce((acc, user) => {
					user.createdByRepresentative ? acc.facilita++ : acc.anticipa++;
					return acc;

				}, { anticipa: 0, facilita: 0 });

				setUsersStats({ ...totalStatusAmount, total: allUsers.items.length });

			} catch (error) {
				throw "Error on loading all the Users ";
			}


		}
		getUsersDefault();
	}, [partner.users]);

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push(`backoffice/partners/${partner.id}/users`);
			return;

		}

		//partnerId, pageNumber, searchTerm, sortByTerm, sortDesc
		dispatch(GetUsersByPartnerId(partner.id, page, search, role, status, sortBy, sortDesc));
	}, [searchQuery.search, history.location]);

	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		// if (pageSearch) {
		// 	history.push(`/backoffice/partners/${partner.id}/users?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${role !== "" ? "&role=" + role : ""}${status !== "" ? "&status=" + status : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
		// 	return;

		// } else {
		// 	history.push(`/backoffice/partners/${partner.id}/users?page=${1}${role !== "" ? "&role=" + role : ""}${status !== "" ? "&status=" + status : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
		// 	return;
		// }

		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/partners/${partner.id}/users?page=${1}${role !== "" ? "&role=" + role : ""}${status !== "" ? "&status=" + status : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(GetUsersByPartnerId(partner.id, page, pageSearch, role, status, sortBy, sortDesc));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);


	const routerQuery = {
		page,
		search,
		role,
		status,
		sortBy,
		sortDesc,
	};

	$('[data-toggle="tooltip"]').tooltip();

	if (partnerState.isLoading.includes(Loadings.FETCHING_USERS) && R.isNil(partner.users)) {
		return <LoadingState />;
	}

	if (R.isNil(partner.users)) {
		return (
			<section className="block fs-3 text-center m-auto py-4">
				<img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
				<div className="block text-center container-thin mx-auto">
					<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'utilisateurs.</h1>
					<p className="o-80 mb-0">Veuillez ajouter un nouvel utilisateur.</p>
				</div>
			</section>
		);
	}


	return (
		<article className="view-calc mb-auto pb-sm">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0">
					<h1 className="sr-only visually-hidden">Partner utilisateurs</h1>
					<div className="row g-1 align-items-center">
						<div className="col">
							<div className="card rounded shadow">
								<div className="card-body media p-2">
									<div className="rounded-max bg-common d-inherit mr-3 h-6 w-6 text-center">
										<img className="img-fluid m-auto my-3 mb-2 py-1 text-white" src={anticipa + "#person-white"} alt="Anticipa" />
									</div>
									<div className="media-body my-auto text-truncate">
										<h2 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Anticipa</h2>
										<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{usersStats.anticipa}</p>
									</div>
								</div>
							</div>
						</div>
						<div className="col">
							<div className="card rounded shadow">
								<div className="card-body media p-2">
									<div className="rounded-max bg-common d-inherit mr-3 h-6 w-6 text-center">
										<img className="img-fluid m-auto my-3 mb-2 py-1" src={facilita} alt="Facilita" />
									</div>
									<div className="media-body my-auto text-truncate">
										<h2 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Facilita</h2>
										<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{usersStats.facilita}</p>
									</div>
								</div>
							</div>
						</div>
						<div className="col">
							<div className="card rounded shadow">
								<div className="card-body media p-2">
									<div className="rounded-max bg-common d-inherit mr-3 h-6 w-6 text-center">
										<img className="img-fluid m-auto my-3 mb-2 py-1" src={usersIcon} alt="users" />
									</div>
									<div className="media-body my-auto text-truncate">
										<h2 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Nombre total</h2>
										<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{usersStats.total} utilisateurs</p>
									</div>
								</div>
							</div>
						</div>
						<div className="col">
							<div className="card rounded shadow" role="button" data-toggle="modal" data-target="#AddPartnerUser" onClick={() => setSelectedUser(undefined)}>
								<div className="card-body p-2 media btn-alert my-auto">
									<div className="rounded-max btn-alert-info d-inherit mr-3 h-6 w-6 rounded-max text-center">
										<i className="eva eva-person-add-outline m-auto fs-4 lh-1" ></i>
									</div>
									<div className="media-body my-auto text-truncate text-info">
										<h2 className="h5 text-uppercase font-weight-bolder my-auto text-truncate">ajouter un <br />nouvel <br />utilisateur</h2>
									</div>
								</div>
							</div>
							<AddPartnerUser partnerId={partner.id} isLoading={isLoading} selectedUser={selectedUser} etablissements={partner.etablissements} />
						</div>
					</div>
				</header>
				<nav className="navbar navbar-expand-sm navbar-light px-0 mb-xl-2 mt-sm mt-xl-0">
					<h1 className="sr-only visually-hidden">Nav</h1>
					<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
						<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
					</button>
					<div className="collapse navbar-collapse flex-column" id="navbarNav">
						<ul className="nav nav-fill nav-pills bg-md-dim rounded-max mt-3">
							<NavLink exact to={`/backoffice/partners/${partner.id}/etablissements`} className="nav-item flex-md-grow-1 text-uppercase rounded-inherit">
								<h2 className="nav-link py-1 px-0 my-auto lh-base">Établissements</h2>
							</NavLink>
							<div className="w-100 mt-1 d-sm-none"></div>
							<NavLink exact to={`/backoffice/partners/${partner.id}/users`} className="nav-item flex-md-grow-1 text-uppercase rounded-inherit">
								<h2 className="nav-link py-1 my-auto lh-base">Utilisateurs</h2>
							</NavLink>
						</ul>
					</div>
				</nav>
			</div>
			<div className="auto-view h-100 mb-auto">
				{/* {
					R.isNil(partner.users) || R.isEmpty(partner.users) ?
						<section className="block fs-3 text-center m-auto py-4">
							<img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
							<div className="block text-center container-thin mx-auto">
								<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'utilisateurs.</h1>
								<p className="o-80 mb-0">Veuillez ajouter un nouvel utilisateur.</p>
							</div>
						</section>
						:
						<UsersTable users={partner.users} setSelectedUser={setSelectedUser} etablissements={partner.etablissements} partnerState={partnerState} partner={partner} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
					} */}
				<UsersTable users={partner.users} setSelectedUser={setSelectedUser} etablissements={partner.etablissements} partnerState={partnerState} partner={partner} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
			</div>
			<div className="container-fluid">
				<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
					{partnerState.usersPagination.currentPage > 1 ? <Link to={`/backoffice/partners/${partner.id}/users?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.role !== "" ? "&role=" + routerQuery.role : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
					{partnerState.usersPagination.currentPage > 1 ? <Link to={`/backoffice/partners/${partner.id}/users?page=${partnerState.usersPagination.currentPage - 1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.role !== "" ? "&role=" + routerQuery.role : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

					<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{partnerState.usersPagination.currentPage} de {partnerState.usersPagination.totalPages}</span>

					{partnerState.usersPagination.currentPage !== partnerState.usersPagination.totalPages ? <Link to={`/backoffice/partners/${partner.id}/users?page=${partnerState.usersPagination.currentPage + 1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.role !== "" ? "&role=" + routerQuery.role : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
					{partnerState.usersPagination.currentPage !== partnerState.usersPagination.totalPages ? <Link to={`/backoffice/partners/${partner.id}/users?page=${partnerState.usersPagination.totalPages}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.role !== "" ? "&role=" + routerQuery.role : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
				</nav>
			</div>
			<DeletePartnerUser isLoading={isLoading} selectedUser={selectedUser} etablissements={partner.etablissements} />
		</article>
	);
};